<template>
<div>
  <vs-card class="cstm_vx_card">
    <vs-row vs-justify="space-between" slot="header">
      <h4>Education</h4>
      <vs-button
      v-if="checkEditPermission()"
        type="border"
        color="primary"
        style="font-size: 13.8px; padding: 7px; float: right;"
        @click="addpopup = true"
      >
        Add
      </vs-button>
    </vs-row>
      <div class="vx-row">
        <vs-table :data="educationProps" class="cstm_vuexy_table w-full">
          <template slot="thead">
            <vs-th sort-key="name">Institution Name</vs-th>
            <vs-th sort-key="degree">Degree</vs-th>
            <vs-th sort-key="CurrentYear">Still Studying</vs-th>
            <vs-th sort-key="from">From</vs-th>
            <vs-th sort-key="to">To</vs-th>
            <vs-th sort-key="certificate">Certificate</vs-th>
            <vs-th sort-key="status" style="width: 250px;">Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(item, indextr) in data">
              <vs-td :data="data[indextr].institute">
                {{ data[indextr].institute }}
              </vs-td>

              <vs-td :data="data[indextr].degree">
                {{ data[indextr].degree }}
              </vs-td>
              <vs-td :data="data[indextr].still_studying">
                {{ data[indextr].still_studying === 1? 'Yes': 'No' }}
              </vs-td>
              <vs-td :data="data[indextr].start_from">
                {{ data[indextr].start_from | moment('MMM-YYYY') }}
              </vs-td>
              <vs-td :data="data[indextr].end_to">
                <span v-if="data[indextr].still_studying === 0">
                {{ data[indextr].end_to | moment('MMM-YYYY') }}
                </span>
              </vs-td>
              <vs-td :data="data[indextr].certificate_picture">
                {{data[indextr].certificate_picture}}
                <a v-if="data[indextr].certificate_picture" :href="data[indextr].certificate_picture" target="_blank">view certificate

                  
                </a>
                <span v-else>Unavailable</span>
              </vs-td>
              <vs-td :data="data[indextr]">
                <vs-row vs-type="flex">
                  <vs-button color="primary" type="filled" icon="edit" class="mr-2" @click="handleedit(indextr)"/>
                  <vs-button type="filled" @click="remove(indextr)" icon="delete" color="danger"/>
                </vs-row>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>

    <vs-popup classContent="popup-example"  title="Delete" :active.sync="deletepopup">
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>

    <vs-popup classContent="popup-example"  title="Add Education" :active.sync="addpopup">
      <form data-vv-scope="add">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="institute" v-model="education.institute" class="custom_Input" label="Institution Name" icon-pack="feather" icon="icon-edit" icon-after style="width:100%;" />
              <span v-show="errors.has('add.institute')" class="text-danger">{{ errors.first('add.institute') }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input v-validate="'required'" name="degree" v-model="education.degree" class="custom_Input" label="Degree" icon-pack="feather" icon="icon-edit" icon-after style="width:100%;" />
            <span v-show="errors.has('add.degree')" class="text-danger">{{ errors.first('add.degree') }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <span style="font-size:11px;"> Still Studying</span>
            <v-select v-validate="'required'" :options="option" label="label" name="still-studying" :reduce="option => option.value" v-model="education.still_studying" />
              <span v-show="errors.has('still-studying')" class="text-danger">{{ errors.first('still-studying') }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="6" :vs-lg="6" class="p-2">
            <span style="font-size:11px;">From</span>
            <datepicker  v-validate="'required'" name="from" :minimumView="'month'" :maximumView="'year'" :disabled-dates="disabledDates" format="MM-yyyy"  v-model="education.start_from" class="w-full edu_from_datepicker"/>
            <span v-show="errors.has('add.from')" class="text-danger">{{ errors.first('add.from') }}</span>
          </vs-col>
          <vs-col v-if="education.still_studying===0" :vs-xs="12" :vs-md="6" :vs-lg="6" class="p-2">
            <span style="font-size:11px;">To</span>
            <datepicker v-validate="'required'" name="to" value="date"  :minimumView="'month'" :maximumView="'year'" :disabled-dates="disabledDates1" format="MM-yyyy" v-model="education.end_to" class="w-full"/>
            <span v-show="errors.has('add.to')" class="text-danger">{{ errors.first('add.to') }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2 centerx">
            <label class="block mb-4" for="myfile">Upload a certificate:</label>
            <div>
             
 <FileUpload :platform_module_id="2" @changingImage="saveImage"></FileUpload>
            </div>
           
            <!-- <input type="file" id="myfile" name="myfile" @change="uploadImg($event, 1)"> -->
          
            <!-- <vs-button color="primary" @click="saveImage">Upload</vs-button> -->
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="addpopup  = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>

    <vs-popup classContent="popup-example"  title="Edit Education" :active.sync="editpopup">
      <form data-vv-scope="edit">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="institute" v-model="edit.institute" class="custom_Input" label="Institution Name" icon-pack="feather" icon="icon-edit" icon-after style="width:100%;" />
              <span v-show="errors.has('edit.institute')" class="text-danger">{{ errors.first('edit.institute') }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-model="edit.degree" v-validate="'required'" name="degree" class="custom_Input" label="Degree" icon-pack="feather" icon="icon-edit" icon-after style="width:100%;" />
              <span v-show="errors.has('edit.degree')" class="text-danger">{{ errors.first('edit.degree') }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <span style="font-size:11px;"> Still Studying</span>
            <v-select :options="option" v-validate="'required'" name="still-Studying" label="label" :reduce="option => option.value" v-model="edit.still_studying" />
              <span v-show="errors.has('edit.still-Studying')" class="text-danger">{{ errors.first('edit.still-Studying') }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="6" :vs-lg="6" class="p-2">
            <span style="font-size:11px;">From</span>
            <datepicker :minimumView="'month'" v-validate="'required'" name="from" :maximumView="'year'" v-model="edit.start_from" format="MM-yyyy" class="w-full"/>
              <span v-show="errors.has('edit.from')" class="text-danger">{{ errors.first('edit.from') }}</span>
          </vs-col>
          <vs-col v-if="edit.still_studying=== 0" :vs-xs="12" :vs-md="6" :vs-lg="6" class="p-2">
            <span style="font-size:11px;">To</span>
            <datepicker :minimumView="'month'" v-validate="'required'" name="to"  :maximumView="'year'" v-model="edit.end_to" format="MM-yyyy" class="w-full"/>
            <span v-show="errors.has('edit.to')" class="text-danger">{{ errors.first('edit.to') }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2 centerx" vs-type="flex" vs-justify="space-between">
            <!-- {{ imageDataUrl }} -->
            <div><label for="myfile">Upload Certificate:</label>
            <FileUpload :platform_module_id="2" @changingImage="saveImageedit" :image="edit.certificate_picture" ></FileUpload>
            <!-- <input type="file" id="myfile" name="myfile" @change="uploadImg($event, 1)"> -->
            </div>
            <!-- <vs-button color="primary" @click="saveImageedit">Upload</vs-button> -->
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdate">Save</vs-button>
        <vs-button type="border" color="danger" @click="editpopup = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>

</div>
</template>
<script>
import FileUpload from '@/views/pages/v1/user_profile/components/profile/personal_information/certificateFile.vue'

import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import {  TeacherUpdate } from '@/api/teacher'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  name: 'email',
  components: {
    Datepicker,
    vSelect,
    FileUpload
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  props: {
    educationProps:{
      required:true,
      type:Array,
      default: () => []
    },
    havePermission:{
      default: false
    }

  },
  watch:{
    educationProps:{
      deep:true,
      immediate:true,
      handler () {
        this.educationAvailability = this._.cloneDeep(this.educationProps)
      }
    },
    education:{
      deep:true,
      immediate:true,
      handler () {
        if (this.education.start_from) {
          this.disabledDates1 = {
            to: this.education.start_from
          }
        }
      }
    }
  },
  data () {
    return {
      disabledDates: null,
      disabledDates1: null,
      addpopup: false,
      deletepopup:false,
      editpopup: false,
      education: {
        certificate_picture: null,
        degree: null,
        institute: null,
        still_studying: 1,
        start_from: null,
        end_to: null
      },
      edit: {
        certificate_picture: null,
        degree: null,
        institute: null,
        still_studying: null,
        start_from: null,
        end_to: null
      },
      editIndex: null,
      deleteindex: false,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true
      },
      imageDataUrl: null,
      option:[
        {
          label:'Yes',
          value: 1
        },
        {
          label:'No',
          value: 0
        }
      ],
      fileName: ''
    }
  },
  /*  computed: {
    localvalue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }, */
  mounted () {
    const today = new Date()
    const year = today.getFullYear() 
    const month = today.getMonth()
    
    this.disabledDates = {

      // to: new Date(2021, 6, 6)
      from: new Date(year, month)
    }
     
  },
  methods: {
    saveImage (url) {
      this.education.certificate_picture = url
    },
    saveImageedit (url) {
      this.edit.certificate_picture = url
    },
    handlePhonedefault (index) {
      this.educationAvailability.map(item => {
        item.default = 0
      })
      this.educationAvailability[index].default = 1
    },
    handleSave () {
      this.$validator.validateAll('add').then(result => {
        if (result) {
          const __temp = this.education
          __temp.start_from = this.formatDate(__temp.start_from)
          __temp.end_to = this.education.still_studying === 0 ? this.formatDate(__temp.end_to) : null
          __temp.certificate_picture = this.education.certificate_picture
          this.educationAvailability.push(__temp)
          this.educationProps = this.educationAvailability
          this.handleEducationsave()

        }
      })
    },
    async handleEducationsave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            educations: this.educationAvailability
          }
        }
        const {data} = await TeacherUpdate(
          payload,
          this.$route.params.teacher_id,
          customer_id
        )
        // this.setAfterUpdate(data)
        this.addpopup = false
        this.editpopup  = false

        this.education = {
          certificate_picture: null,
          degree: null,
          institute: null,
          still_studying: 1,
          start_from: null,
          end_to: null
        }

        this.$emit('setAfterUpdate', data)
        // this.fetchTeacherDetails(this.$route.params.teacher_id)
        // this.bioEditPopup = false
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')

      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    },
    handleedit (index) {
      
      this.editpopup = true
      const temp = this.educationAvailability[index]
      this.edit.year_from = `${temp.month_from}-${temp.year_from}`
      this.edit.year_to = `${temp.month_to}-${temp.year_to}`
      this.edit = temp
      this.editIndex =  index
    },
    handleUpdate () {
      // 
      this.$validator.validateAll('edit').then(result => {
        if (result) {
          const payload = this.edit
          this.educationAvailability[this.editIndex] = payload
          this.educationProps = this.educationAvailability
          this.handleEducationsave()
        }
      })
    },
    handleDelete () {
      this.handleEducationsave()

      this.educationAvailability.splice(this.deleteindex, 1)
      this.deletepopup = false
    },
    remove (index) {
      this.deletepopup = true
      this.deleteindex = index
    },
    uploadImg (e, num) {
      const file = e.target.files[0]
      const FileType = file.type
      this.fileName = FileType.replace('/', '.')
      const fileSize = ((e.target.files[0].size / 1024) / 1024)
      if (fileSize < 5) {
        // this.dialogVisible = true
        // 
        // if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        //   alert('File Should be must this (.gif,jpeg,jpg,png,bmp) type')
        //   return false
        // }
        const reader = new FileReader()
        reader.onload = (e) => {
          const formData = new FormData()
          formData.append('myFile', file)
          let data = null
          if (typeof e.target.result === 'object') {
            data = new Blob([e.target.result])
            // fd.append('upload_path', 'FeedWall')
          } else {
            data = e.target.result
          }
          if (num === 1) {
            this.imageDataUrl = data
          } else if (num === 2) {
            this.example2.img = data
          }
        }
        reader.readAsArrayBuffer(file)
        // 
      } else {
        this.option.img = ''
    
        this.dialogVisible = false
        this.$vs.notify({
          title:'warning',
          text: 'Image sie is too large',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color:'warning'
        })
        return false
      }
    },
    // async saveImageedit () {
    //   try {
    //     // const payload = {
    //     //   image: this.imageDataUrl
    //     // }
    //     const fd = new FormData()
    //     fd.append('files[]', this.imageDataUrl, this.fileName)
    //     // fd.append('upload_path', 'FeedWall')
    //     const customer_id = this.$store.state.LoginStorage.user_details.customer_id
    //     const { data } = await UploadImage(fd, customer_id)
    //     this.edit.certificate_picture = `${data.data.scoolio_cdn}${data.data.files[0].file_path}`
    //     // 
    //     this.$vs.notify({
    //       title:'Success',
    //       text: 'file uploaded Successfully',
    //       icon: 'feather',
    //       iconPack: 'icon-alert-circle',
    //       color:'success'
    //     })
    //   } catch (e) {
    //     this.$vs.notify({
    //       title:'error',
    //       text: e,
    //       icon: 'feather',
    //       iconPack: 'icon-alert-circle',
    //       color:'danger'
    //     })
    //   }
    // },
    //  async ImageChanged (imageUrl) {
    //   try {
    //     const payload = {
    //       updateField: {
    //         picture: imageUrl
           
    //       }
    //     }
    //     const customer_id = localStorage.getItem('customer_id')
        
    //     if (finalLanguages.platform_languages_id.length > 0) {
    //       payload.updateField.languages = finalLanguages
    //     }
    //     const { data } = await TeacherUpdate(
    //       payload,
    //       this.$route.params.teacher_id,
    //       customer_id
    //     )
    //     this.teacherPersonalDetails = data.data.operationalUser
    //     if (this.teacherPersonalDetails.address.length === 0) {
    //       this.teacherPersonalDetails.address = [
    //         {
    //           address1: '',
    //           address2: '',
    //           city: '',
    //           id: '',
    //           state: '',
    //           zip: ''
    //         }
    //       ]
    //     }
    //     if (this.teacherPersonalDetails.phone.length > 0) {
    //       const temm = this.teacherPersonalDetails.phone
    //       temm.map((item) => {
    //         if (item.default === '1') {
    //           item.default = 1
    //         } else {
    //           item.default = 0
    //         }
    //       })
    //       this.teacherPersonalDetails.phone = temm
    //     }
    //     if (this.teacherPersonalDetails.email.length > 0) {
    //       const temm_ = this.teacherPersonalDetails.email
    //       temm_.map((item) => {
    //         if (item.default === '1') {
    //           item.default = 1
    //         } else {
    //           item.default = 0
    //         }
    //       })
    //       this.teacherPersonalDetails.email = temm_
    //     }
    //     if (this.teacherPersonalDetails.availability.length === 0) {
          
    //       this.teacherPersonalDetails.availability = []
    //     }
        
    //     this.firstNameedit = false
    //     this.lastNameEdit = false
    //     this.basicDetails = this.teacherPersonalDetails.basic_details
    //     this.$vs.notify({
    //       title: 'Updated',
    //       text: 'Staff Updated Successfully',
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'success'
    //     })
        
    //   } catch (e) {
        
    //     this.$vs.notify({
    //       title: 'Error',
    //       text: e.message,
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'danger'
    //     })
    //   }
    //   // 
    // },
   
    formatDate (date) {
      const d = new Date(date)
      let month = `${(d.getMonth() + 1)}`
      let day = `${d.getDate()}`
      const year = `${d.getFullYear()}`
      if (month.length < 9) {
        month = `0${ month}`
      }
      if (day.length < 2) {
        day = `0${day}`
      }
      return [year, month, day].join('-')
    }
  }
}
</script>

